import React from "react";
import { Box } from "@mui/material";

import { CarriersProvider } from "./contexts/carriersContext";
import { MOCK_STATS } from "./mock";
import { CarriersRepDirectoryHeader, DirectoryTab } from "./sections";

export const CarriersRepDirectory = (): React.JSX.Element => (
  <Box display="flex" flexDirection="column" flex={1} minHeight={0}>
    <CarriersRepDirectoryHeader stats={MOCK_STATS} />

    <Box pt={2} flex={1} minHeight={0}>
      <CarriersProvider>
        <DirectoryTab />
      </CarriersProvider>
    </Box>
  </Box>
);
